'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ListAdapter2 = require('./ListAdapter');

var _ListAdapter3 = _interopRequireDefault(_ListAdapter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmptyListAdapter = function (_ListAdapter) {
  _inherits(EmptyListAdapter, _ListAdapter);

  function EmptyListAdapter() {
    _classCallCheck(this, EmptyListAdapter);

    return _possibleConstructorReturn(this, (EmptyListAdapter.__proto__ || Object.getPrototypeOf(EmptyListAdapter)).apply(this, arguments));
  }

  _createClass(EmptyListAdapter, [{
    key: 'getLength',
    value: function getLength() {
      return 0;
    }
  }, {
    key: 'filter',
    value: function filter() {
      return [];
    }
  }, {
    key: 'find',
    value: function find() {}
  }, {
    key: 'toArray',
    value: function toArray() {
      return [];
    }
  }]);

  return EmptyListAdapter;
}(_ListAdapter3['default']);

exports['default'] = EmptyListAdapter;


// WEBPACK FOOTER //
// ./src/modules/autosuggest/EmptyListAdapter.js